import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SmsOtpResponse } from '../../../../transaction-signing-widget/src/components/signing-components/bb-sms-otp-signing/sms-otp.model';
import { OtpAction, OtpWebChallengeData } from '../../interfaces';
import { OtpService } from '../../services/otp.service';

@Component({
  selector: 'bn-otp-verification-code',
  templateUrl: './banesco-otp-verification-code.component.html',
})
export class BanescoOtpVerificationCodeComponent implements OnInit {
  @Output() complete = new EventEmitter<SmsOtpResponse>();
  @Output() resend = new EventEmitter<OtpAction>();
  @Output() cancel = new EventEmitter<{ action: string }>();
  @Input() data!: OtpWebChallengeData;
  readonly expectedOtpLength = 6;
  isResend = false;
  errorCode?: string;
  errorComplement?: string;

  displayIncorrectAlert = false;
  displayMissingAlert = false;
  displayRemainingAlert = false;
  displayResendAlert = false;
  displayResendLink = true;

  readonly form: FormGroup = this.formBuilder.group({
    otp: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]],
  });

  constructor(private readonly formBuilder: FormBuilder) {}

  ngOnInit() {
    this.isResend = OtpService.isResend;

    this.errorCode = this.data?.error;

    if (this.data?.resendOtpAttemptResult === 'errorSendingOtpNotAllowed') {
      this.errorCode = 'wait_for_attempt';
      this.isResend = false;

      if (this.data?.resendOtpTimeLapse) {
        const waitMessage = $localize`:@@otp-validation-please-wait:Please wait`;
        const secondsMessage = $localize`:@@otp-validation-seconds:seconds and try again`;
        this.errorComplement = `${waitMessage} ${this.data?.resendOtpTimeLapse} ${secondsMessage}`;
      }
    }

    if (this.data?.resendOtpAttemptCount && this.data?.resendOtpMaxCount) {
      this.displayResendLink = +this.data?.resendOtpAttemptCount < +this.data?.resendOtpMaxCount;
    }
  }

  onComplete(): void {
    OtpService.isResend = false;
    this.clearAlerts();
    if (this.form.valid) {
      return this.complete.emit({ action: 'validate', ...this.form.value });
    }

    if (!this.form.value.otp || !this.form.value.otp.length) {
      this.displayMissingAlert = true;
      this.form.markAllAsTouched();
    }

    if (this.form.controls.otp.errors && this.form.controls.otp.errors.pattern) {
      this.displayIncorrectAlert = true;
      this.form.reset();
      this.form.markAllAsTouched();
    }
  }

  onResend(): void {
    OtpService.isResend = true;
    this.resend.emit(OtpService.currentOtpMethod);
  }

  onCancel(): void {
    OtpService.isResend = false;
    this.cancel.emit({ action: 'cancel' });
  }

  private clearAlerts(): void {
    this.displayIncorrectAlert = false;
    this.displayMissingAlert = false;
    this.displayRemainingAlert = false;
    this.displayResendAlert = false;
  }
}
